var _path, _path2, _circle, _rect, _rect2, _rect3, _path3, _circle2, _circle3, _circle4, _circle5, _circle6, _path4, _path5, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _circle7, _circle8, _rect17, _path6, _polygon, _path7, _polygon2, _path8, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _polygon3, _polygon4, _rect28, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _ellipse, _ellipse2, _path19, _path20, _path21, _path22, _circle9, _polygon5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgOrganize = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  id: "b07e7c8b-ffb9-458f-9d0a-e368c1cfe139",
  "data-name": "Layer 1",
  xmlns: "http://www.w3.org/2000/svg",
  width: 1020,
  height: 612,
  viewBox: "0 0 1020 612",
  ref: ref,
  "aria-labelledby": titleId
}, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, "online_organizer") : title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M569.75916,855.19685l-26.49227-74.17837s29.1415,14.57075,30.46612,33.11534c0,0-6.62307-92.723-19.86921-112.59217,0,0,21.19382,2.64923,45.03687,105.9691,0,0,3.97384-119.21524-31.79073-153.6552,0,0,49.01071,39.73842,52.98455,125.83831v75.503Z",
  transform: "translate(-290 -244)",
  fill: "#f2f2f2"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M1066.59028,855.19685l-6.36981-17.83546s7.00679,3.50339,7.32528,7.96226c0,0-1.59245-22.29433-4.77735-27.07168,0,0,5.09584.637,10.82867,25.47923,0,0,.95547-28.66414-7.64377-36.94488,0,0,11.78414,9.55471,12.73961,30.25658v18.154Z",
  transform: "translate(-290 -244)",
  fill: "#f2f2f2"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 658.58268,
  cy: 341.33858,
  r: 116.45669,
  fill: "#f2f2f2"
})), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  y: 8.83465,
  width: 274.67717,
  height: 152.59843,
  fill: "#f2f2f2"
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  x: 372.66142,
  y: 8.83465,
  width: 274.67717,
  height: 152.59843,
  fill: "#f2f2f2"
})), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
  x: 745.32283,
  y: 8.83465,
  width: 274.67717,
  height: 152.59843,
  fill: "#f2f2f2"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M996.08615,855.61568c-.18431-.30118-4.53026-7.55776-6.03695-22.62623-1.382-13.82453-.49334-37.12685,11.59155-69.63166,22.89447-61.5782-5.27616-111.26289-5.564-111.7578l1.38983-.80628c.07294.12549,7.34207,12.79313,11.63625,32.96443a143.81285,143.81285,0,0,1-5.95617,80.15966c-22.85525,61.4731-5.86362,90.57394-5.6895,90.861Z",
  transform: "translate(-290 -244)",
  fill: "#3f3d56"
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 697.13386,
  cy: 393.54331,
  r: 10.44094,
  fill: "#009688"
})), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
  cx: 730.06299,
  cy: 432.09449,
  r: 10.44094,
  fill: "#3f3d56"
})), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
  cx: 707.5748,
  cy: 457.79528,
  r: 10.44094,
  fill: "#009688"
})), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
  cx: 734.88189,
  cy: 479.48031,
  r: 10.44094,
  fill: "#009688"
})), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
  cx: 699.54331,
  cy: 513.2126,
  r: 10.44094,
  fill: "#3f3d56"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M1002.3937,856s-10.44094-25.70079,20.88189-44.97638Z",
  transform: "translate(-290 -244)",
  fill: "#3f3d56"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "M989.553,855.5338s-4.75177-27.33065-41.52966-27.09641Z",
  transform: "translate(-290 -244)",
  fill: "#3f3d56"
})), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
  x: 0.40157,
  width: 273.87402,
  height: 13.65354,
  fill: "#3f3d56"
})), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
  x: 373.06299,
  width: 274.67717,
  height: 13.65354,
  fill: "#3f3d56"
})), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
  x: 745.72441,
  width: 273.87402,
  height: 13.65354,
  fill: "#3f3d56"
})), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
  x: 20.88189,
  y: 34.93701,
  width: 49.79528,
  height: 35.33858,
  fill: "#fff"
})), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
  x: 116.45669,
  y: 34.93701,
  width: 137.33858,
  height: 4.01575,
  fill: "#fff"
})), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
  x: 116.45669,
  y: 51,
  width: 137.33858,
  height: 4.01575,
  fill: "#fff"
})), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
  x: 116.45669,
  y: 67.06299,
  width: 137.33858,
  height: 4.01575,
  fill: "#fff"
})), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
  x: 393.54331,
  y: 34.93701,
  width: 49.79528,
  height: 35.33858,
  fill: "#fff"
})), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
  x: 489.11811,
  y: 34.93701,
  width: 137.33858,
  height: 4.01575,
  fill: "#fff"
})), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
  x: 489.11811,
  y: 51,
  width: 137.33858,
  height: 4.01575,
  fill: "#fff"
})), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
  x: 489.11811,
  y: 67.06299,
  width: 137.33858,
  height: 4.01575,
  fill: "#fff"
})), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
  x: 766.20472,
  y: 34.93701,
  width: 49.79528,
  height: 35.33858,
  fill: "#fff"
})), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
  x: 861.77953,
  y: 34.93701,
  width: 137.33858,
  height: 4.01575,
  fill: "#fff"
})), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
  x: 861.77953,
  y: 51,
  width: 137.33858,
  height: 4.01575,
  fill: "#fff"
})), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
  x: 861.77953,
  y: 67.06299,
  width: 137.33858,
  height: 4.01575,
  fill: "#fff"
})), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
  cx: 45.77953,
  cy: 53.00787,
  r: 16.06299,
  fill: "#009688"
})), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
  cx: 791.10236,
  cy: 53.00787,
  r: 16.06299,
  fill: "#009688"
})), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
  x: 126.71411,
  y: 161.43307,
  width: 1.6063,
  height: 4.8189,
  fill: "#3f3d56"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  d: "M418.3204,603.00787h-1.60629v-9.63779h1.60629Zm0-19.27559h-1.60629v-9.63779h1.60629Zm0-19.27559h-1.60629V554.8189h1.60629Zm0-19.27559h-1.60629v-9.63779h1.60629Zm0-19.27559h-1.60629v-9.63779h1.60629Zm0-19.27559h-1.60629v-9.63779h1.60629Zm0-19.27559h-1.60629v-9.63779h1.60629Zm0-19.27559h-1.60629v-9.6378h1.60629Zm0-19.27559h-1.60629v-9.6378h1.60629Zm0-19.27559h-1.60629v-9.6378h1.60629Z",
  transform: "translate(-290 -244)",
  fill: "#3f3d56"
})), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
  points: "132.336 374.268 126.714 374.268 126.714 368.646 128.32 368.646 128.32 372.661 132.336 372.661 132.336 374.268",
  fill: "#3f3d56"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  d: "M1158.1608,618.26772h-9.68172v-1.6063h9.68172Zm-19.36343,0h-9.68172v-1.6063h9.68172Zm-19.36344,0h-9.6825v-1.6063h9.6825Zm-19.36422,0H1090.388v-1.6063h9.68171Zm-19.36343,0h-9.6825v-1.6063h9.6825Zm-19.36422,0h-9.68172v-1.6063h9.68172Zm-19.36344,0h-9.6825v-1.6063h9.6825Zm-19.36422,0h-9.68171v-1.6063h9.68171Zm-19.36343,0h-9.6825v-1.6063h9.6825Zm-19.36422,0H974.205v-1.6063h9.68172Zm-19.36344,0h-9.6825v-1.6063h9.6825Zm-19.36421,0h-9.68172v-1.6063h9.68172Zm-19.36344,0h-9.6825v-1.6063h9.6825Zm-19.36422,0h-9.68172v-1.6063h9.68172Zm-19.36343,0H877.3855v-1.6063H887.068Zm-19.36422,0h-9.68172v-1.6063h9.68172Zm-19.36344,0h-9.6825v-1.6063h9.6825Zm-19.36422,0h-9.68172v-1.6063h9.68172Zm-19.36343,0h-9.68211v-1.6063h9.68211Zm-19.36383,0h-9.68211v-1.6063h9.68211Zm-19.36383,0h-9.68211v-1.6063H770.885Zm-19.36382,0h-9.68211v-1.6063h9.68211Zm-19.36383,0h-9.68211v-1.6063h9.68211Zm-19.36383,0h-9.68211v-1.6063h9.68211Zm-19.36383,0h-9.68211v-1.6063h9.68211Zm-19.36382,0H664.3838v-1.6063h9.68211Zm-19.36383,0H645.02v-1.6063h9.68211Zm-19.36383,0h-9.68211v-1.6063h9.68211Zm-19.36383,0h-9.6821v-1.6063h9.6821Zm-19.36382,0h-9.68211v-1.6063h9.68211Zm-19.36383,0h-9.68211v-1.6063h9.68211Zm-19.36383,0h-9.68171v-1.6063h9.68171Zm-19.36382,0H528.8374v-1.6063h9.68172Zm-19.36383,0h-9.68172v-1.6063h9.68172Zm-19.36383,0h-9.68172v-1.6063h9.68172Zm-19.36383,0h-9.68171v-1.6063h9.68171Zm-19.36382,0h-9.68172v-1.6063h9.68172Zm-19.36383,0h-9.68172v-1.6063H441.7Z",
  transform: "translate(-290 -244)",
  fill: "#3f3d56"
})), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
  points: "883.465 374.268 877.843 374.268 877.843 372.661 881.858 372.661 881.858 368.646 883.465 368.646 883.465 374.268",
  fill: "#3f3d56"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  d: "M1173.46457,603.00787h-1.6063v-9.63779h1.6063Zm0-19.27559h-1.6063v-9.63779h1.6063Zm0-19.27559h-1.6063V554.8189h1.6063Zm0-19.27559h-1.6063v-9.63779h1.6063Zm0-19.27559h-1.6063v-9.63779h1.6063Zm0-19.27559h-1.6063v-9.63779h1.6063Zm0-19.27559h-1.6063v-9.63779h1.6063Zm0-19.27559h-1.6063v-9.6378h1.6063Zm0-19.27559h-1.6063v-9.6378h1.6063Zm0-19.27559h-1.6063v-9.6378h1.6063Z",
  transform: "translate(-290 -244)",
  fill: "#3f3d56"
})), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
  x: 881.85827,
  y: 161.43307,
  width: 1.6063,
  height: 4.8189,
  fill: "#3f3d56"
})), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
  x: 372.66142,
  y: 325.27559,
  width: 274.67717,
  height: 285.92126,
  fill: "#3f3d56"
})), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
  x: 393.54331,
  y: 362.62205,
  width: 49.79528,
  height: 35.33858,
  fill: "#fff"
})), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
  x: 489.11811,
  y: 362.62205,
  width: 137.33858,
  height: 4.01575,
  fill: "#fff"
})), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
  x: 489.11811,
  y: 378.68504,
  width: 137.33858,
  height: 4.01575,
  fill: "#fff"
})), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
  x: 489.11811,
  y: 394.74803,
  width: 137.33858,
  height: 4.01575,
  fill: "#fff"
})), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
  x: 393.54331,
  y: 489.92126,
  width: 49.79528,
  height: 35.33858,
  fill: "#fff"
})), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
  x: 489.11811,
  y: 489.92126,
  width: 137.33858,
  height: 4.01575,
  fill: "#fff"
})), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
  x: 489.11811,
  y: 505.98425,
  width: 137.33858,
  height: 4.01575,
  fill: "#fff"
})), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
  x: 489.11811,
  y: 522.04724,
  width: 137.33858,
  height: 4.01575,
  fill: "#fff"
})), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
  points: "418.652 389.229 401.607 366.503 405.645 363.475 419.53 381.989 454.923 353.324 458.119 357.23 418.652 389.229",
  fill: "#009688"
})), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
  points: "418.652 515.324 401.607 492.598 405.645 489.57 419.53 508.083 454.923 479.418 458.119 483.325 418.652 515.324",
  fill: "#009688"
})), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
  x: 7.22835,
  y: 610.3937,
  width: 991.88976,
  height: 1.6063,
  fill: "#3f3d56"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  d: "M834.57387,414.26772s26.50393-11.54886,38.95275.65077S840.19591,423.10236,834.57387,414.26772Z",
  transform: "translate(-290 -244)",
  fill: "#3f3d56"
})), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
  d: "M880.33918,359.49668c-8.90681-15.04974-26.52821-15.75113-26.52821-15.75113s-17.171-2.19581-28.18616,20.72513c-10.267,21.3642-24.4367,41.99177-2.28122,46.993l4.00193-12.45578,2.47837,13.3831a86.68625,86.68625,0,0,0,9.47951.162c23.72674-.766,46.32287.22413,45.59531-8.29C883.93154,392.94459,888.90931,373.97754,880.33918,359.49668Z",
  transform: "translate(-290 -244)",
  fill: "#2f2e41"
})), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
  d: "M892.80221,632.32283s-11.24409,20.88189-18.47244,20.88189-6.4252,13.65355-4.8189,16.86615,5.62205,10.44094-.80315,20.88189c-2.24432,3.647-1.84284,7.784-.37009,11.62368,4.12646,10.75826,20.17827,7.49888,19.66619-4.01223q-.00848-.19035-.02051-.38311c-.80315-12.85039,5.62205-32.92913,12.04725-37.748s12.04724-17.66929,12.04724-17.66929Z",
  transform: "translate(-290 -244)",
  fill: "#ffb8b8"
})), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
  d: "M815.69985,627.50394s11.24409,20.88189,18.47244,20.88189,6.4252,13.65354,4.8189,16.86614-5.622,10.44094.80315,20.88189c2.24432,3.647,1.84284,7.784.37009,11.62368-4.12646,10.75827-20.17827,7.49888-19.66619-4.01223q.00847-.19035.02051-.38311c.80315-12.85039-5.622-32.92913-12.04725-37.748s-12.04724-17.66929-12.04724-17.66929Z",
  transform: "translate(-290 -244)",
  fill: "#ffb8b8"
})), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
  d: "M824.53449,524.70079l-4.81889,10.44094s-70.67717,23.29134-64.252,50.59843,37.748,69.874,42.56693,68.26771,30.51968-6.42519,31.32283-20.07874-18.47244-37.748-18.47244-37.748l26.50394-24.09449,38.56752-.80315L908.8652,596.1811s-34.53543,30.51969-19.27559,42.56693,37.748,20.07874,40.96063,15.25984,39.35433-76.29921,33.73229-82.72441-62.64567-30.51968-62.64567-30.51968l-15.25985-21.685-59.43307-3.2126Z",
  transform: "translate(-290 -244)",
  fill: "#2f2e41"
})), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
  d: "M838.99119,392.1811s4.01575,26.50394-4.01575,29.71654,16.063,16.86614,16.063,16.86614H864.692l8.83464-18.47244s-8.0315-14.45669-3.2126-28.11024S838.99119,392.1811,838.99119,392.1811Z",
  transform: "translate(-290 -244)",
  fill: "#ffb8b8"
})), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
  d: "M838.99119,392.1811s4.01575,26.50394-4.01575,29.71654,16.063,16.86614,16.063,16.86614H864.692l8.83464-18.47244s-8.0315-14.45669-3.2126-28.11024S838.99119,392.1811,838.99119,392.1811Z",
  transform: "translate(-290 -244)",
  opacity: 0.1
})), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
  d: "M833.36914,414.66929s8.83465,9.6378,10.44095,11.2441,8.83464,10.44094,24.09448-2.40945,16.86615,2.40945,16.86615,2.40945v96.378s-12.8504-5.622-23.29134,0-32.126-1.6063-32.126-1.6063l-4.01575-99.59055Z",
  transform: "translate(-290 -244)",
  fill: "#fff"
})), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
  d: "M839.26859,414.66929s-7.50575-3.2126-13.931,0-28.91338,19.27559-27.30708,26.50394S820.51875,499,806.06205,523.09449s-16.86614,30.51968-16.86614,30.51968l35.33858-18.47244s27.30709-16.86614,24.89764-27.30708S839.26859,414.66929,839.26859,414.66929Z",
  transform: "translate(-290 -244)",
  fill: "#009688"
})), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
  d: "M871.12665,414.66929s16.85666,1.6063,17.65981,3.2126,25.29922,8.43307,23.69292,15.66142-23.69292,71.88189-14.05512,83.92913,25.70079,28.91339,20.07874,30.51969-15.25984-2.40945-24.89764,0-32.126-17.6693-29.71653-39.35433S863.90777,420.29134,871.12665,414.66929Z",
  transform: "translate(-290 -244)",
  fill: "#009688"
})), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
  d: "M830.95969,568.07087v8.03149s-4.01575,18.47244,8.83465,17.66929,4.8189-22.48819,4.8189-22.48819l-.80315-7.22834Z",
  transform: "translate(-290 -244)",
  fill: "#ffb8b8"
})), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
  d: "M867.10142,568.874s-8.83464,18.47244,0,20.07874,15.25985-10.441,15.25985-13.65355S867.10142,568.874,867.10142,568.874Z",
  transform: "translate(-290 -244)",
  fill: "#ffb8b8"
})), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
  cx: 588.74709,
  cy: 137.33858,
  rx: 1.6063,
  ry: 3.2126,
  fill: "#ffb8b8"
})), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 541.36127,
  cy: 137.33858,
  rx: 1.6063,
  ry: 3.2126,
  fill: "#ffb8b8"
})), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
  d: "M892.80221,425.11024s20.07874,0,19.27559,8.03149S884.77072,579.315,884.77072,579.315s-11.2441-10.44094-20.88189-8.0315Z",
  transform: "translate(-290 -244)",
  fill: "#009688"
})), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
  d: "M814.8967,427.51969s-20.07874,4.01574-20.07874,16.063,28.91339,127.70078,32.92913,127.70078,19.27559-2.40944,19.27559-6.42519S814.8967,427.51969,814.8967,427.51969Z",
  transform: "translate(-290 -244)",
  fill: "#009688"
})), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
  d: "M819.314,451.2126l18.07087,70.67S828.95182,460.04724,819.314,451.2126Z",
  transform: "translate(-290 -244)",
  opacity: 0.2
})), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
  d: "M889.60328,441.28263l-18.27637,92.39721S877.16812,446.6125,889.60328,441.28263Z",
  transform: "translate(-290 -244)",
  opacity: 0.2
})), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
  cx: 565.05418,
  cy: 137.74016,
  r: 23.29134,
  fill: "#ffb8b8"
})), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
  points: "586.401 114.046 568.992 104.927 544.951 108.657 539.977 130.626 552.359 130.15 555.818 122.079 555.818 130.017 561.531 129.797 564.847 116.947 566.92 130.626 587.23 130.212 586.401 114.046",
  fill: "#2f2e41"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgOrganize);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/organize.5c7cadad065a107c33e3e9c6ca236f1a.svg";